(() => {
  if (customElements.get('horizontal-slider')) {
    return;
  }

  class HorizontalSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('horizontal-slider', HorizontalSlider);
})();
